import {
    REBOOT_DEVICE_OPEN_MODAL,
    REBOOT_DEVICE_CLOSE_MODAL,
    REBOOT_DEVICE_REQUEST,
    REBOOT_DEVICE_RESULT,
    REBOOT_DEVICE_GET_DEVICE_REQUEST,
    REBOOT_DEVICE_GET_DEVICE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    devices: [],
    device: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case REBOOT_DEVICE_OPEN_MODAL:
            return { ...state, openModal: true, devices: action.payload }

        case REBOOT_DEVICE_CLOSE_MODAL:
            return { ...state, openModal: false }

        case REBOOT_DEVICE_REQUEST:
            return { ...state, loading: true }

        case REBOOT_DEVICE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case REBOOT_DEVICE_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case REBOOT_DEVICE_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case CLEAR_REDUX:
            return ["", "REBOOT_DEVICE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }

        default:
            return state;
    }
};